// extracted by mini-css-extract-plugin
module.exports = {"radio":"TotalCampaignBudgetField_radio__1Z2Zc","sending":"TotalCampaignBudgetField_sending__2oGNz"};